import { formatCurrency } from '../../utils/index.ts';

/** One RAD-funding liquidation row (manual control / suggestion-engine RAD funding key -> amount). */
export interface RadFundingLiquidation {
    amount?: number;
    [key: string]: unknown;
}

/** Keyed by asset-type id (or a manual `type-id` key) -> one or many liquidations. */
export type RadFundingBag = Record<string, RadFundingLiquidation | RadFundingLiquidation[] | undefined>;

export interface RadFundingTooltipRow {
    label: string;
    value: string;
}

const LABELS: Record<string, string> = {
    bankAccounts: 'Bank accounts',
    accountBasedPensions: 'Account-based pensions',
    shares: 'Shares',
    familyHome: 'Family home'
};

/** Tooltip rows for RAD funding sell-downs (CalculationTooltip / Deep Dive). */
export function getRadFundingTooltipData(radFunding: RadFundingBag | null | undefined): RadFundingTooltipRow[] | null {
    if (!radFunding || typeof radFunding !== 'object') return null;
    const data: RadFundingTooltipRow[] = [];
    Object.entries(radFunding).forEach(([type, liquidations]) => {
        const list = Array.isArray(liquidations) ? liquidations : (liquidations ? [liquidations] : []);
        const total = list.reduce((sum, l) => sum + (l?.amount || 0), 0);
        if (total > 0) data.push({ label: LABELS[type] || type, value: formatCurrency(total) });
    });
    return data.length ? data : null;
}
